export default __webpack_public_path__ + "static/media/github.46065ca9.svg";